import api from '../api';
import { TypeRate } from '../models/profile';

const baseUrl = 'pwa/profile';
export class ProfileService {
  public feedback = (data: { comment: string; rate: TypeRate }) =>
    api.post(`${baseUrl}/add-feedback-app`, data);
}

const profileService = new ProfileService();
export default profileService;
